/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { defineMessages } from '@nebula/izzy/intl';
import Copy from '@nebula/luna/dist/core/copy';
import Well from '@react/react-spectrum/Well';

import ConnectionMethod from '../connection.method';
import PinField from '../pin.field';

import styles from './styles/connect.content.styl';

const MSG = defineMessages({
  connected: {
    id: 'gemini.session.create.connected',
    defaultMessage: 'You are now connected to the session.'
  },
  connecting: {
    id: 'gemini.session.create.connecting',
    defaultMessage: 'To secure and start your session, choose your connection method, and enter the PIN for your device.'
  }
});

const SessionCreateConnectContent = ({
  connecting = true,
  image,
  izzy,
  link,
  pin
}) => (
  <div
    data-omega-element="connect session"
    data-omega-widget="connect session"
    data-omega-widget-type="modal"
  >
    <Copy className={styles.description}>
      {connecting ? izzy(MSG.connecting) : izzy(MSG.connected)}
    </Copy>
    <div
      className={styles.image}
    >
      <img alt="" src={image} />
    </div>
    {connecting && (
      <Well>
        <ConnectionMethod
          izzy={izzy}
          link={link}
        />
        <PinField
          izzy={izzy}
          pin={pin}
        />
      </Well>
    )}
  </div>
);

SessionCreateConnectContent.displayName = 'SessionCreateConnectContent';
export default SessionCreateConnectContent;
